export default __webpack_public_path__ + "static/preview_en-a99a8da7d8a56006d24afd59d62f903c.jpg";